/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FaqsInputs */

const en_nav_faqs = /** @type {(inputs: Nav_FaqsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

const fr_nav_faqs = /** @type {(inputs: Nav_FaqsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {Nav_FaqsInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_faqs = /** @type {((inputs?: Nav_FaqsInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FaqsInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_faqs(inputs)
	return fr_nav_faqs(inputs)
});